/**
 * Return the given URL only if it is safe to use as an href: an http(s) or
 * relative URL. Anything else (javascript:, data:, etc.) or an invalid value
 * returns undefined, so callers can omit the href / render a non-link element.
 * The original string is returned when safe, so relative URLs keep their form.
 */
export function safeUrl (url) {
  if (typeof url !== 'string' || url === '') return undefined

  try {
    const dest = new URL(url, window.location.origin)
    if (dest.protocol === 'http:' || dest.protocol === 'https:') {
      return url
    }
  } catch (err) {
    // Not a parseable URL.
  }

  return undefined
}
